import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, GetMethodResponse, ListMethodArg, ListMethodResponse, ModelClass, References } from '/imports/types';
import { validateBoolean, validateString } from '/imports/validators';
import { SmaClientPlant, SmaClientAccessToken as _SmaClientAccessToken } from '/server/integrations/smaClient';

export interface SmaClientMeter extends Omit<Doc, 'name'>, SmaClientPlant {
  _id: string;
  meterId: string;
  accessTokenId: string;
}
export type Model = SmaClientMeter;

export const SmaClientMeters = new Mongo.Collection<SmaClientMeter>('smaClientMeters');

type Refs = References<Model>

export const modelClass: ModelClass<Model, Refs> = {
  collection: SmaClientMeters,
  editableFields: ['active'],
  listMethod: DeclareMethod<ListMethodArg<SmaClientMeter>, ListMethodResponse<SmaClientMeter, Refs>>('listSmaClientMeters'),
  getMethod: DeclareMethod<string, GetMethodResponse<SmaClientMeter, Refs>>('getSmaClientMeter'),
  createMethod: DeclareMethod<Partial<SmaClientMeter>, string>('createSmaClientMeter'),
  updateMethod: DeclareMethod<Partial<SmaClientMeter>, string>('updateSmaClientMeter'),
  deleteMethod: DeclareMethod<string>('deleteSmaClientMeter'),
  pathPrefix: '/sma-client-meters',
  asString: (document) => document.name || `${document.plantId}` || document._id,
  modelName: 'SMA Client',
  pluralName: 'SMA Client',
  searchQuery: (search?: string) => {
    search = search?.trim();
    if (!search?.length) return {};
    return {
      $or: [
        { _id: search },
        { name: new RegExp(search, 'gi') },
      ]
    };
  },
  validate: async (document: Partial<SmaClientMeter>) => {
    const errors: { [key: string]: string[] } = {};
    validateBoolean(errors, document, 'active');
    validateString(errors, document, 'meterId', { required: true });
    return errors;
  },
};

Meteor.isServer && Meteor.startup(async () => {
  await SmaClientMeters.createIndexAsync({ meterId: 1 });
  await SmaClientMeters.createIndexAsync({ accessTokenId: 1 });
});

export interface SmaClientAccessToken extends _SmaClientAccessToken {
  _id: string;
  orgId: string;
  username: string;
  password: string; // encrypted at rest via /server/utils encrypt()
  clientId?: string;
}

export const SmaClientAccessTokens = new Mongo.Collection<SmaClientAccessToken>('smaClientAccessTokens');

export const createSmaClientAccessToken = DeclareMethod<{ username: string, password: string }, { _id: string, username: string }>('createSmaClientAccessToken');
export const getSmaClientAccessTokensForOrg = DeclareMethod<string, SmaClientAccessToken[]>('getSmaClientAccessTokensForOrg');
export const pullSmaClientPlantsForToken = DeclareMethod<string, { numPlants: number, numCreated: number }>('pullSmaClientPlantsForToken');

Meteor.isServer && Meteor.startup(async () => {
  await SmaClientAccessTokens.createIndexAsync({ orgId: 1 });
});
